import { Link } from 'react-router-dom';
import { hotVideos } from '@/mocks/videos';
import VideoCard from '@/components/feature/VideoCard';

export default function HotSection() {
  return (
    <section className="w-full px-4 md:px-6 py-8 md:py-10 bg-background-100">
      <div className="flex items-center justify-between mb-5">
        <div className="flex items-center gap-2">
          <div className="w-1 h-5 rounded-full bg-primary-500"></div>
          <h2 className="text-lg md:text-xl font-heading font-bold text-foreground-900">
            热门推荐
          </h2>
        </div>
        <Link
          to="/category/movie"
          className="flex items-center gap-1 text-sm text-foreground-500 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap"
        >
          查看更多
          <i className="ri-arrow-right-s-line"></i>
        </Link>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-4">
        {hotVideos.map((video) => (
          <VideoCard key={video.id} video={video} size="sm" />
        ))}
      </div>
    </section>
  );
}